/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { errorResponseSchema } from "./errorResponseSchema.ts";
import { mobileOrderDevicePayByTrackRequestSchema } from "./mobileOrderDevicePayByTrackRequestSchema.ts";
import { mobileOrderDevicePayResponseSchema } from "./mobileOrderDevicePayResponseSchema.ts";

export const orderPayByTrackCreatePathOrderIdSchema = z.uuid();

export const orderPayByTrackCreateStatus200Schema = mobileOrderDevicePayResponseSchema;

export const orderPayByTrackCreateStatus400Schema = errorResponseSchema;

export const orderPayByTrackCreateResponseSchema = z.union([orderPayByTrackCreateStatus200Schema, orderPayByTrackCreateStatus400Schema]);

export const orderPayByTrackCreateDataSchemaJson = mobileOrderDevicePayByTrackRequestSchema;

export const orderPayByTrackCreateDataSchemaXml = mobileOrderDevicePayByTrackRequestSchema;

export const orderPayByTrackCreateDataSchema = z.union([orderPayByTrackCreateDataSchemaJson, orderPayByTrackCreateDataSchemaXml]);
